import type { CreateProps } from "react-admin";
import {
  TextInput,
  Create,
  SimpleForm,
  SelectInput,
  BooleanInput,
  DateInput,
} from "react-admin";
import { EMPLOYEE_TYPE } from "@/constants";
import { StaffPayrollSetupIncompleteBanner } from "@/containers/staff/shared/StaffPayrollSetupIncompleteBanner";

import {
  EMPLOYEE_GENDER_CHOICES,
  transformStaffEmployeePayload,
  type StaffEmployeeFormValues,
} from "./staff-employee-form";

const StaffCreate = (props: CreateProps) => (
  <Create
    {...props}
    redirect="list"
    transform={(data) => transformStaffEmployeePayload(data as StaffEmployeeFormValues)}
  >
    <SimpleForm warnWhenUnsavedChanges sx={{ maxWidth: 500 }}>
      <StaffPayrollSetupIncompleteBanner dense />
      <TextInput source="name" isRequired fullWidth />
      <TextInput source="phone" isRequired fullWidth />
      <SelectInput
        label="Type"
        source="type"
        key={1}
        choices={Object.entries(EMPLOYEE_TYPE).map(([id, name]) => ({ id, name }))}
        sx={{ marginBottom: 0 }}
        alwaysOn
      />
      <DateInput source="joinedOn" label="Joined on" fullWidth />
      <DateInput source="leftOn" label="Left on" fullWidth />
      <SelectInput
        source="gender"
        label="Gender"
        choices={EMPLOYEE_GENDER_CHOICES}
        emptyText="—"
        resettable
        fullWidth
        helperText="Required for Maharashtra professional tax when payroll is enabled"
      />
      <BooleanInput
        label="Receive Booking Summaries via WhatsApp"
        source="receiveBookingSummary"
        fullWidth
        defaultValue={false}
      />
      <BooleanInput label="Active" source="isActive" fullWidth defaultValue={true} />
    </SimpleForm>
  </Create>
);

export default StaffCreate;
